export default {
	name: 'school-business',
	path: '/school-business',
	meta: {
		title: '运营中心'
	},
	redirect: '/school-business/advert',
	children: [
		//版本说明
		{
			name: 'business-versionUpdate',
			path: 'versionUpdate',
			fullPath: '/school-business/versionUpdate',
			meta: {
				title: '版本说明',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/versionUpdate/index.vue')
		},
		// 广告管理
		{
			name: 'business-advert',
			path: 'advert',
			fullPath: '/school-business/advert',
			meta: {
				title: '广告管理'
			},
			redirect: '/school-business/advert/search',
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert'),
			children: [
				{
					name: 'advert-search',
					path: 'search',
					fullPath: '/school-business/advert/search',
					meta: {
						// title: '查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/search')
				},
				{
					name: 'advert-add',
					path: 'add',
					fullPath: '/school-business/advert/add',
					meta: {
						// title: '添加'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/add')
				},
				{
					name: 'advert-statistics',
					path: 'statistics',
					fullPath: '/school-business/advert/statistics',
					meta: {
						// title: '广告统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/statistics')
				},
				{
					name: 'advert-collateStatistics',
					path: 'collateStatistics',
					fullPath: '/school-business/advert/collateStatistics',
					meta: {
						// title: '核对广告统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/collateStatistics')
				},
				{
					name: 'advert-export',
					path: 'export',
					fullPath: '/school-business/advert/export',
					meta: {
						// title: '导出月度广告'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/export')
				},
				{
					name: 'advert-linkStatistics',
					path: 'linkStatistics',
					fullPath: '/school-business/advert/linkStatistics',
					meta: {
						// title: '查看链接统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/linkStatistics')
				},
				{
					name: 'advert-getLinkStatistics',
					path: 'getLinkStatistics',
					fullPath: '/school-business/advert/getLinkStatistics',
					meta: {
						// title: '获取统计链接'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/getLinkStatistics')
				},
				{
					name: 'advert-configuration',
					path: 'configuration',
					fullPath: '/school-business/advert/configuration',
					meta: {
						title: '广告配置'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/advert/configuration')
				}
			]
		},
		// 数据统计
		{
			name: 'business-data',
			path: 'data',
			fullPath: '/school-business/data',
			meta: {
				title: '数据统计'
			},
			redirect: '/school-business/data/user',
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/data'),
			children: [
				{
					name: 'data-user',
					path: 'user',
					fullPath: '/school-business/data/user',
					meta: {
						// title: '用户统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/data/user')
				},
				{
					name: 'data-distribute',
					path: 'distribute',
					fullPath: '/school-business/data/distribute',
					meta: {
						// title: '学校分布'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/data/distribute')
				}
			]
		},
		{
			name: 'business-winning',
			path: 'winning',
			fullPath: '/school-business/winning',
			meta: {
				// title: '中奖通知',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/winning')
		},
		{
			name: 'business-area',
			path: 'area',
			fullPath: '/school-business/area',
			meta: {
				// title: '地区编辑',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/area')
		},
		{
			name: 'business-suggestion',
			path: 'suggestion',
			fullPath: '/school-business/suggestion',
			meta: {
				// title: '通知反馈',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/suggestion')
		},
		{
			name: 'business-appOpen',
			path: 'appOpen',
			fullPath: '/school-business/appOpen',
			meta: {
				// title: '开通设置',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/appOpen')
		},
		{
			name: 'business-application',
			path: 'application',
			fullPath: '/school-business/application',
			meta: {
				// title: '应用管理',
				icon: 'icon-home'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/application')
		},
		// 设备运营
		{
			name: 'business-device',
			path: 'device',
			fullPath: '/school-business/device',
			meta: {
				title: '设备运营'
			},
			redirect: '/school-business/device/productionPlan',
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/device'),
			children: [
				{
					name: 'device-productionPlan',
					path: 'productionPlan',
					fullPath: '/school-business/device/productionPlan',
					meta: {
						// title: '入库管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/productionPlan')
				},
				{
					name: 'device-orderManage',
					path: 'orderManage',
					fullPath: '/school-business/device/orderManage',
					meta: {
						// title: '订购管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/orderManage')
				},
				{
					name: 'device-deviceAdmin',
					path: 'deviceAdmin',
					fullPath: '/school-business/device/deviceAdmin',
					meta: {
						// title: '设备管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdmin')
				},
				{
					name: 'device-repair',
					path: 'repair',
					fullPath: '/school-business/device/repair',
					meta: {
						// title: '返修管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/repair')
				},
				{
					name: 'device-check',
					path: 'check',
					fullPath: '/school-business/device/check',
					redirect: '/school-business/device/check/deviceStock',
					meta: {
						title: '统计查询'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check'),
					children: [
						{
							name: 'check-deviceStock',
							path: 'deviceStock',
							fullPath: '/school-business/device/check/deviceStock',
							meta: {
								// title: '设备库存'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/deviceStock')
						},
						{
							name: 'check-stock',
							path: 'stock',
							fullPath: '/school-business/device/check/stock',
							redirect: '/school-business/device/check/stock/other',
							meta: {
								title: '库存管理'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/stock'),
							children: [
								{
									name: 'stock-other',
									path: 'other',
									fullPath: '/school-business/device/check/stock/other',
									meta: {
										// title: '其他库存'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/stock/other')
								},
								{
									name: 'stock-depotList',
									path: 'depotList',
									fullPath: '/school-business/device/check/stock/depotList',
									meta: {
										// title: '库存变动明细'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/stock/depotList')
								}
							]
						},
						{
							name: 'check-orderCensus',
							path: 'orderCensus',
							fullPath: '/school-business/device/check/orderCensus',
							meta: {
								// title: '发货统计'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/orderCensus')
						},
						{
							name: 'check-repairCensus',
							path: 'repairCensus',
							fullPath: '/school-business/device/check/repairCensus',
							meta: {
								// title: '返修统计'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/repairCensus')
						},
						{
							name: 'check-repairDetails',
							path: 'repairDetails',
							fullPath: '/school-business/device/check/repairDetails',
							meta: {
								title: '返修明细'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/check/repairDetails')
						}
					]
				},
				{
					name: 'config-manage',
					path: 'config',
					fullPath: '/school-business/device/config',
					redirect: '/school-business/device/config/baseMessage',
					meta: {
						title: '配置管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config'),
					children: [
						{
							name: 'config-baseMessage',
							path: 'baseMessage',
							fullPath: '/school-business/device/config/baseMessage',
							redirect: '/school-business/device/config/baseMessage/check',
							meta: {
								// title: '基础信息设置'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/baseMessage'),
							children: [
								{
									name: 'baseMessage-check',
									path: 'check',
									fullPath: '/school-business/device/config/baseMessage/check',
									meta: {
										// title: '查看产品信息'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/baseMessage/check')
								},
								{
									name: 'baseMessage-add',
									path: 'add',
									fullPath: '/school-business/device/config/baseMessage/add',
									meta: {
										// title: '添加产品信息'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/baseMessage/add')
								}
							]
						},
						{
							name: 'config-typeMessage',
							path: 'typeMessage',
							fullPath: '/school-business/device/config/typeMessage',
							redirect: '/school-business/device/config/typeMessage/check',
							meta: {
								title: '类型信息设置'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/typeMessage'),
							children: [
								{
									name: 'typeMessage-check',
									path: 'check',
									fullPath: '/school-business/device/config/typeMessage/check',
									meta: {
										// title: '查看产品类型'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/typeMessage/check')
								},
								{
									name: 'typeMessage-add',
									path: 'add',
									fullPath: '/school-business/device/config/typeMessage/add',
									meta: {
										// title: '添加产品类型'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/typeMessage/add')
								}
							]
						},
						{
							name: 'config-fixBug',
							path: 'fixBug',
							fullPath: '/school-business/device/config/fixBug',
							meta: {
								// title: '维修问题配置'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/fixBug')
						},
						{
							name: 'config-preferential',
							path: 'preferential',
							fullPath: '/school-business/device/config/preferential',
							redirect: '/school-business/device/config/preferential/check',
							meta: {
								// title: '优惠配置'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/preferential'),
							children: [
								{
									name: 'preferential-check',
									path: 'check',
									fullPath: '/school-business/device/config/preferential/check',
									meta: {
										// title: '查看优惠'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/preferential/check')
								},
								{
									name: 'preferential-add',
									path: 'add',
									fullPath: '/school-business/device/config/preferential/add',
									meta: {
										// title: '添加优惠'
									},
									component: () =>
										import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/config/preferential/add')
								}
							]
						}
					]
				},
				{
					name: 'device-deviceAdminOld',
					path: 'deviceAdminOld',
					fullPath: '/school-business/device/deviceAdminOld',
					redirect: '/school-business/device/deviceAdminOld/check',
					meta: {
						title: '设备管理(旧版)'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld'),
					children: [
						{
							name: 'deviceAdminOld-check',
							path: 'check',
							fullPath: '/school-business/device/deviceAdminOld/check',
							meta: {
								// title: '查看'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld/check')
						},
						{
							name: 'deviceAdminOld-add',
							path: 'add',
							fullPath: '/school-business/device/deviceAdminOld/add',
							meta: {
								// title: '添加'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld/add')
						},
						{
							name: 'deviceAdminOld-import',
							path: 'import',
							fullPath: '/school-business/device/deviceAdminOld/import',
							meta: {
								// title: '导入'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld/import')
						},
						{
							name: 'deviceAdminOld-watch',
							path: 'watch',
							fullPath: '/school-business/device/deviceAdminOld/watch',
							meta: {
								// title: '监控'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld/watch')
						},
						{
							name: 'deviceAdminOld-question',
							path: 'question',
							fullPath: '/school-business/device/deviceAdminOld/question',
							meta: {
								// title: '设备问题管理'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/deviceAdminOld/question')
						}
					]
				},
				{
					name: 'device-version',
					path: 'versionManage',
					fullPath: '/school-business/device/versionManage',
					meta: {
						// title: '版本管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/versionManage')
				},
				{
					name: 'device-update',
					path: 'update',
					fullPath: '/school-business/device/update',
					redirect: '/school-business/device/update/check',
					meta: {
						// title: '升级管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/update'),
					children: [
						{
							name: 'update-check',
							path: 'check',
							fullPath: '/school-business/device/update/check',
							meta: {
								// title: '查看'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/update/check')
						},
						{
							name: 'update-add',
							path: 'add',
							fullPath: '/school-business/device/update/add',
							meta: {
								// title: '添加'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/update/add')
						}
					]
				},
				{
					name: 'device-card',
					path: 'card',
					fullPath: '/school-business/device/card',
					redirect: '/school-business/device/card/check',
					meta: {
						// title: '卡管理'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card'),
					children: [
						{
							name: 'card-check',
							path: 'check',
							fullPath: '/school-business/device/card/check',
							meta: {
								// title: '查看'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/check')
						},
						{
							name: 'card-statistics',
							path: 'statistics',
							fullPath: '/school-business/device/card/statistics',
							meta: {
								// title: '加密卡统计'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/statistics')
						},
						{
							name: 'card-add',
							path: 'add',
							fullPath: '/school-business/device/card/add',
							meta: {
								// title: '添加'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/add')
						},
						{
							name: 'card-batchAdd',
							path: 'batchAdd',
							fullPath: '/school-business/device/card/batchAdd',
							meta: {
								// title: '批量添加'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/batchAdd')
						},
						{
							name: 'card-checkExist',
							path: 'checkExist',
							fullPath: '/school-business/device/card/checkExist',
							meta: {
								// title: '查询已存在'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/checkExist')
						},
						{
							name: 'card-addImport',
							path: 'addImport',
							fullPath: '/school-business/device/card/addImport',
							meta: {
								// title: '添加卡后,再导无障碍'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/addImport')
						},
						{
							name: 'inquiry-card',
							path: '/inquiry-card',
							meta: {
								title: '查询已存在卡'
							},
							component: () =>
								import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/card/inquiryCard')
						}
					]
				},
				{
					name: 'device-alipayBind',
					path: 'alipayBind',
					fullPath: '/school-business/device/alipayBind',
					meta: {
						// title: '支付宝设备绑定'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/alipayBind')
				},
				{
					name: 'device-remoteControl',
					path: 'remoteControl',
					fullPath: '/school-business/device/remoteControl',
					meta: {
						// title: '远程操作'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/device/remoteControl')
				}
			]
		},
		// 监控管理
		{
			name: 'business-monitor',
			path: 'monitor',
			fullPath: '/school-business/monitor',
			meta: {
				title: '监控管理'
			},
			redirect: '/school-business/monitor/api',
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor'),
			children: [
				{
					name: 'monitor-api',
					path: 'api',
					fullPath: '/school-business/monitor/api',
					meta: {
						// title: 'API访问日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/api')
				},
				{
					name: 'monitor-startupCount',
					path: 'startupCount',
					fullPath: '/school-business/monitor/startupCount',
					meta: {
						// title: '启动次数统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/startupCount')
				},
				{
					name: 'monitor-errorLog',
					path: 'errorLog',
					fullPath: '/school-business/monitor/errorLog',
					meta: {
						// title: '设备错误日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/errorLog')
				},
				{
					name: 'monitor-deviceImport',
					path: 'deviceImport',
					fullPath: '/school-business/monitor/deviceImport',
					meta: {
						// title: '设备导入查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/deviceImport')
				},
				{
					name: 'monitor-temperatureLog',
					path: 'temperatureLog',
					fullPath: '/school-business/monitor/temperatureLog',
					meta: {
						// title: '测温枪日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/temperatureLog')
				},
				{
					name: 'monitor-notRegisteredCardtest',
					path: 'notRegisteredCardtest',
					fullPath: '/school-business/monitor/notRegisteredCardtest',
					meta: {
						// title: '未登录卡日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/notRegisteredCardtest')
				},
				{
					name: 'monitor-deviceStable',
					path: 'deviceStable',
					fullPath: '/school-business/monitor/deviceStable',
					meta: {
						// title: '设备稳定性监控'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/deviceStable')
				},
				{
					name: 'monitor-deviceMaps',
					path: 'deviceMaps',
					fullPath: '/school-business/monitor/deviceMaps',
					meta: {
						// title: '设备分布图'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/deviceMaps')
				},
				{
					name: 'monitor-attendancePushCount',
					path: 'attendancePushCount',
					fullPath: '/school-business/monitor/attendancePushCount',
					meta: {
						// title: '最近15天的考勤推送次数'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/attendancePushCount')
				},
				{
					name: 'monitor-getIndexStatistics',
					path: 'getIndexStatistics',
					fullPath: '/school-business/monitor/getIndexStatistics',
					meta: {
						// title: '系统学校数据统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/getIndexStatistics')
				},
				{
					name: 'monitor-mnsMonitor',
					path: 'mnsMonitor',
					fullPath: '/school-business/monitor/mnsMonitor',
					meta: {
						// title: 'MNS监控'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/mnsMonitor')
				},
				{
					name: 'monitor-activeSwipeStatistics',
					path: 'activeSwipeStatistics',
					fullPath: '/school-business/monitor/activeSwipeStatistics',
					meta: {
						// title: '活跃刷卡（设备/学校）统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/activeSwipeStatistics')
				},
				{
					name: 'monitor-swipePerMinuteStatistics',
					path: 'swipePerMinuteStatistics',
					fullPath: '/school-business/monitor/swipePerMinuteStatistics',
					meta: {
						// title: '当天刷卡每分钟请求数统计'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/swipePerMinuteStatistics')
				},
				{
					name: 'monitor-listCronTabLog',
					path: 'listCronTabLog',
					fullPath: '/school-business/monitor/listCronTabLog',
					meta: {
						// title: 'Crontab定时任务日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/listCronTabLog')
				},
				{
					name: 'monitor-showPhpFpmStatus',
					path: 'showPhpFpmStatus',
					fullPath: '/school-business/monitor/showPhpFpmStatus',
					meta: {
						// title: 'php-fpm进程数监控'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/showPhpFpmStatus')
				},
				{
					name: 'monitor-noticePushCount',
					path: 'noticePushCount',
					fullPath: '/school-business/monitor/noticePushCount',
					meta: {
						// title: '通知公告推送监控'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/noticePushCount')
				},
				{
					name: 'monitor-loginLog',
					path: 'loginLog',
					fullPath: '/school-business/monitor/loginLog',
					meta: {
						// title: '登录日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/loginLog')
				},
				{
					name: 'monitor-operationLog',
					path: 'operationLog',
					fullPath: '/school-business/monitor/operationLog',
					meta: {
						// title: '操作日志'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/operationLog')
				},
				{
					name: 'monitor-readAdd',
					path: 'readAdd',
					fullPath: '/school-business/monitor/readAdd',
					meta: {
						// title: '添加查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/readAdd')
				},
				{
					name: 'monitor-readUpdate',
					path: 'readUpdate',
					fullPath: '/school-business/monitor/readUpdate',
					meta: {
						// title: '修改查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/readUpdate')
				},
				{
					name: 'monitor-readDelete',
					path: 'readDelete',
					fullPath: '/school-business/monitor/readDelete',
					meta: {
						// title: '删除查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/readDelete')
				},
				{
					name: 'monitor-importLog',
					path: 'importLog',
					fullPath: '/school-business/monitor/importLog',
					meta: {
						// title: '导入记录'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/importLog')
				},
				{
					name: 'monitor-deviceMonitor',
					path: 'deviceMonitor',
					fullPath: '/school-business/monitor/deviceMonitor',
					meta: {
						// title: '设备监控'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/deviceMonitor')
				},
				{
					name: 'monitor-getCacheSwitch',
					path: 'getCacheSwitch',
					fullPath: '/school-business/monitor/getCacheSwitch',
					meta: {
						// title: 'memcache开关状态'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/getCacheSwitch')
				},
				{
					name: 'monitor-record',
					path: 'record',
					fullPath: '/school-business/monitor/record',
					meta: {
						// title: '推送记录查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/record')
				},
				{
					name: 'monitor-recordResponse',
					path: 'recordResponse',
					fullPath: '/school-business/monitor/recordResponse',
					meta: {
						// title: '推送响应记录查看'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/recordResponse')
				},
				{
					name: 'monitor-setHttpsBuleGreen',
					path: 'setHttpsBuleGreen',
					fullPath: '/school-business/monitor/setHttpsBuleGreen',
					meta: {
						// title: '设置区域发布'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/monitor/setHttpsBuleGreen')
				}
			]
		},
		// 品牌配置
		{
			name: 'brand-configuration',
			path: '/brand-configuration',
			meta: {
				title: '公众号品牌配置'
			},
			redirect: '/school-business/brand-configuration',
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/brand-configuration'),
			children: [
				{
					name: 'brand-configuration-list',
					path: '/school-business/brand-configuration',
					meta: {
						title: '公众号品牌配置'
					},
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/brand-configuration/list')
				},
				{
					name: 'brand-configuration-config',
					path: '/school-business/brand-configuration/congig/:id',
					component: () =>
						import(/* webpackChunkName: "school-business" */ '@/views/school-business/brand-configuration/config')
				}
			]
		},
		// 设备广告
		{
			name: 'equipment-advertising',
			path: '/equipment-advertising',
			meta: {
				title: '广告管理'
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/equipment-advertising')
		},
		{
			name: 'area-code',
			path: 'area-code',
			fullPath: '/school-business/area-code',
			meta: {
				title: '地区编码',
			},
			component: () =>
				import(/* webpackChunkName: "school-business" */ '@/views/school-business/area-code')
		},
	]
};
